module.exports = __webpack_public_path__ + "static/media/delete.39b6b69a.svg";